export default __webpack_public_path__ + "static/media/PDF.58bfc70f.svg";